import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import csCommon from "./cs/common.json";
import csAuth from "./cs/auth.json";
import csAdmin from "./cs/admin.json";
import csTenant from "./cs/tenant.json";
import csEmails from "./cs/emails.json";

/**
 * react-i18next setup.
 *
 * Default + fallback `cs`. Application is Czech-only v MVP; namespace
 * struktura připravena pro i18next-icu (placeholder %var%) per UX-3 mapping
 * z `spec/normative/GLOSSARY.md`.
 *
 * 5 namespaces — common/auth/admin/tenant/emails — odpovídá REQ-UI-011/012.
 */
export const NAMESPACES = ["common", "auth", "admin", "tenant", "emails"] as const;
export type Namespace = (typeof NAMESPACES)[number];

const resources = {
  cs: {
    common: csCommon,
    auth: csAuth,
    admin: csAdmin,
    tenant: csTenant,
    emails: csEmails,
  },
} as const;

if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: "cs",
      fallbackLng: "cs",
      supportedLngs: ["cs"],
      ns: [...NAMESPACES],
      defaultNS: "common",
      interpolation: {
        escapeValue: false,
        prefix: "%",
        suffix: "%",
      },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "axigon.lang",
      },
      returnNull: false,
      saveMissing: import.meta.env?.DEV ?? false,
      missingKeyHandler: (_lng, ns, key) => {
        if (import.meta.env?.DEV) {
          console.error(`[i18n] Missing key: ${ns}:${key}`);
        }
      },
    });
}

export default i18n;
